import { render, staticRenderFns } from "./Lyricists.vue?vue&type=template&id=5ece2014&"
import script from "./Lyricists.vue?vue&type=script&lang=js&"
export * from "./Lyricists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ece2014')) {
      api.createRecord('5ece2014', component.options)
    } else {
      api.reload('5ece2014', component.options)
    }
    module.hot.accept("./Lyricists.vue?vue&type=template&id=5ece2014&", function () {
      api.rerender('5ece2014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Lyricists.vue"
export default component.exports